module.exports = __webpack_public_path__ + "img/paypal.48de1322.png";